var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritingonthewallRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.86,
    y: 235.05,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.73,
    y: 164.83,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 235.05,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.35,
    y: 248.26,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.37,
    y: 248.26,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.39,
    y: 248.26,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.41,
    y: 248.26,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.84,
    y: 261.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.86,
    y: 261.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.88,
    y: 261.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.24,
    y: 275.83,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.92,
    y: 261.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.35,
    y: 274.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.37,
    y: 274.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.39,
    y: 274.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.41,
    y: 274.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.16,
    y: 100.5,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.18,
    y: 100.5,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.65,
    y: 113.71,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.67,
    y: 113.71,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.71,
    y: 113.71,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.73,
    y: 113.71,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.18,
    y: 126.91,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.79,
    y: 177.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.81,
    y: 177.8,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.28,
    y: 191.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.3,
    y: 191.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.08,
    y: 164.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.09,
    y: 164.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.57,
    y: 177.68,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.59,
    y: 177.68,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.79,
    y: 204.21,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.81,
    y: 204.21,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.22,
    y: 126.91,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.14,
    y: 100.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.15,
    y: 100.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.65,
    y: 114.06,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.27,
    y: 101.07,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.29,
    y: 101.07,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.76,
    y: 114.27,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.6,
    y: 137.13,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.8,
    y: 114.27,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.25,
    y: 127.48,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.27,
    y: 127.48,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.29,
    y: 127.48,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.76,
    y: 140.69,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.78,
    y: 140.69,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.4,
    y: 231.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.42,
    y: 231.47,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.86,
    y: 232.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.89,
    y: 244.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.91,
    y: 244.67,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.35,
    y: 245.88,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.37,
    y: 245.88,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.97,
    y: 203.18,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.08,
    y: 196.89,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.56,
    y: 156.34,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.48,
    y: 189.97,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.46,
    y: 189.97,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.75,
    y: 373.27,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.24,
    y: 360.07,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.4,
    y: 257.88,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.42,
    y: 257.88,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.89,
    y: 271.09,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.91,
    y: 271.09,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.75,
    y: 307.62,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.76,
    y: 307.62,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.78,
    y: 307.62,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8,
    y: 307.62,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.24,
    y: 320.83,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.26,
    y: 320.83,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.29,
    y: 320.83,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.73,
    y: 334.03,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.75,
    y: 334.03,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.76,
    y: 334.03,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.24,
    y: 347.24,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.26,
    y: 347.24,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.27,
    y: 347.24,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.28,
    y: 307.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.3,
    y: 307.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.32,
    y: 307.01,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.77,
    y: 320.22,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.79,
    y: 320.22,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.81,
    y: 320.22,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.83,
    y: 320.22,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.26,
    y: 333.42,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.28,
    y: 333.42,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.3,
    y: 372.45,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.32,
    y: 372.45,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 346.63,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.79,
    y: 346.63,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.81,
    y: 346.63,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.83,
    y: 346.63,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8,
    y: 359.65,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.29,
    y: 372.86,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.29,
    y: 359.04,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.8,
    y: 372.25,
    width: 22.3,
    height: 9.49,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--drawing-text--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67,146.12,157.52,157h-7.26l2.2-11.2-8.07-20.17h7.26l5.6,14,11.25-14H176Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,143.92c0-10.71,7.84-18.82,19.41-18.82,9.54,0,15.28,5.56,15.28,13.63,0,10.71-7.85,18.82-19.41,18.82C178.14,157.55,172.4,152,172.4,143.92Zm27.34-4.79c0-4.66-3.05-7.84-8.56-7.84-7.08,0-11.43,5.6-11.43,12.23,0,4.66,3.05,7.84,8.56,7.84C195.39,151.36,199.74,145.76,199.74,139.13Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,146.57a18.14,18.14,0,0,1,.36-3.36l3.49-17.57h7.31l-3.5,17.43a15.57,15.57,0,0,0-.26,2.65c0,3.81,2.15,5.64,6.05,5.64,4.39,0,6.94-2.42,8.15-8.29l3.5-17.43h7.12l-3.54,17.88c-1.88,9.28-7.21,14-16,14C216.14,157.55,211.39,153.34,211.39,146.57Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.22,143.92c0-10.71,7.85-18.82,19.5-18.82,5.56,0,10.08,2,12.32,5.56L284.8,135c-1.61-2.37-4.12-3.67-7.57-3.67-7.09,0-11.66,5.42-11.66,12.19,0,4.75,3.14,7.88,8.79,7.88a10.91,10.91,0,0,0,8.33-3.63l4.3,4.4c-3.31,3.85-7.88,5.42-13.26,5.42C264.14,157.55,258.22,152,258.22,143.92Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.78,150.29H297.17L293.09,157h-7.75l20.3-31.37h7.17L320.52,157h-7.26Zm-1.21-5.51-2.65-12.1-7.39,12.1Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,125.64,352.56,157h-6l-11.7-19.63L331,157h-7.17l6.27-31.37h6l11.7,19.67,3.9-19.67Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,163.28h13.13c9.68,0,15.46,5.06,15.46,13.08,0,11.07-7.93,18.29-19.54,18.29H172.74Zm9.28,25.41c7.53,0,12-5.11,12-11.92,0-4.66-3-7.53-8.91-7.53h-6.23l-3.9,19.45Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(200.66 113.19)",
    style: {
      fontSize: "41.607521057128906px",
      fill: "#263238",
      fontFamily: "Satisfy-Regular, Satisfy"
    }
  }, "Believe"), /*#__PURE__*/React.createElement("path", {
    d: "M245,172.8s-.15,2.86-.81,2.79-.6-2.11-.6-2.11-.39,3.5-.89,3.68-.91-2.8-.91-2.8-.17,2.95-.44,3-.51-2.57-.51-2.57-.48,3.67-.81,3.67-.33-3.11-.57-3-.74,4.46-.94,4.46c0,0-.06-.14-.07-.47a13,13,0,0,0-.42-3.29,5.49,5.49,0,0,1,0,.58c0,6.63-4.35,12.23-11.43,12.23-5.51,0-8.56-3.18-8.56-7.84a12.24,12.24,0,0,1,6-10.88,11.94,11.94,0,0,1,4-1.18,3.41,3.41,0,0,1-.85,0,10.48,10.48,0,0,1,1.72-.24L230.4,164a18.19,18.19,0,0,0-5.35.37c-2.07.54,1-.64,2.68-.89,0,0-2.53-.34-6.83,1.28-6.3,3.05-10.16,9.29-10.16,16.8,0,8.07,5.74,13.63,15.28,13.63,11.57,0,19.41-8.12,19.41-18.83A15.17,15.17,0,0,0,245,172.8Z",
    style: {
      fill: "#FAAE17"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.66,394.76s1.26-9.27,7.19-10.28,4.13-5.5,5.68-7.23,5.57,3.38,2.12,8.34-.63,3.4-2.12,8S129.11,402.44,129.66,394.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66,394.76s1.26-9.27,7.19-10.28,4.13-5.5,5.68-7.23,5.57,3.38,2.12,8.34-.63,3.4-2.12,8S129.11,402.44,129.66,394.76Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,400.67l-.13,0a.45.45,0,0,1-.3-.56c0-.1,2.86-10.11-1.86-24.61a63.85,63.85,0,0,0-5.58-11.93c-4-7.13-7.49-13.29-4.1-25.59,1-3.8,2.17-7.36,3.26-10.81,4-12.69,7.15-22.72,2.26-31.35a.45.45,0,0,1,.17-.62.45.45,0,0,1,.61.17c5.09,9,1.88,19.17-2.18,32.07-1.09,3.44-2.2,7-3.25,10.78-3.29,11.94-.07,17.67,4,24.91a64.63,64.63,0,0,1,5.66,12.09c4.81,14.79,1.9,25,1.86,25.14A.44.44,0,0,1,130.67,400.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.32,398.92s3.83-5.77-1.7-8.74-6.63-.58-10.05-2.71-6-7.31-6.6-4,3.37,5.2,2,6.71S126.24,401.52,133.32,398.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,300.07s1.87-11.79-6.55-10.66S123,299.51,127,300.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,309.87s-4.15-9.78-9.75-6.66S115.21,311,121.11,309.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,309.11s-2.22-8,4.07-9.17S140,306.34,131.34,309.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,326.36s7.24-8.93,11.2-3.81S135.76,330.38,129.84,326.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,327.46s-3.63-12.28-9.83-7.23S108.89,329.68,114.64,327.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.55,346.39s3-13.49-6.17-10.53S104.42,344.4,111.55,346.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,348.57s6.41-10.63,12.94-8.66S142.72,352,126.68,348.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.86,370.42s-9.19-13.89-14.37-7.86S114.37,374.54,122.86,370.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,368s-3.68-11.34,3.15-11.5S141.92,363.7,132.53,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127,300.07s1.87-11.79-6.55-10.66S123,299.51,127,300.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,309.87s-4.15-9.78-9.75-6.66S115.21,311,121.11,309.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,309.11s-2.22-8,4.07-9.17S140,306.34,131.34,309.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,326.36s7.24-8.93,11.2-3.81S135.76,330.38,129.84,326.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,327.46s-3.63-12.28-9.83-7.23S108.89,329.68,114.64,327.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.55,346.39s3-13.49-6.17-10.53S104.42,344.4,111.55,346.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,348.57s6.41-10.63,12.94-8.66S142.72,352,126.68,348.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.86,370.42s-9.19-13.89-14.37-7.86S114.37,374.54,122.86,370.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,368s-3.68-11.34,3.15-11.5S141.92,363.7,132.53,368Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.79,316.06h-.05a.46.46,0,0,1-.31-.18c0-.05-4.24-5.67-6.88-6.72a.45.45,0,0,1,.33-.84c2.49,1,6,5.33,7,6.65a30,30,0,0,0,6.73-9,.45.45,0,0,1,.6-.22.46.46,0,0,1,.22.6c-.12.25-2.83,6.08-7.34,9.67A.48.48,0,0,1,125.79,316.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,332.86h0a.45.45,0,0,1-.33-.16c0-.06-5.13-6.11-10.74-8.29a.45.45,0,1,1,.32-.84c5.07,2,9.56,6.78,10.79,8.18,6.37-6.4,15.12-7.6,15.49-7.65a.46.46,0,0,1,.51.39.45.45,0,0,1-.39.51c-.09,0-9.13,1.26-15.3,7.72A.47.47,0,0,1,120.65,332.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.11,354.22a.46.46,0,0,1-.23-.06c-5.72-3.24-11.23-12.69-11.46-13.09a.45.45,0,1,1,.78-.45c0,.09,5.45,9.34,10.87,12.6,1.56-1.25,10-7.73,17-9a.44.44,0,0,1,.53.36.45.45,0,0,1-.37.52c-7.41,1.36-16.74,9-16.84,9A.43.43,0,0,1,119.11,354.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54,374.5a.42.42,0,0,1-.32-.13A22.53,22.53,0,0,0,115.93,369a.45.45,0,0,1-.39-.51.47.47,0,0,1,.51-.39,23.63,23.63,0,0,1,12.5,5.38c3.24-3.06,6.51-13.12,6.55-13.23a.45.45,0,1,1,.85.28c-.14.45-3.59,11-7.13,13.91A.42.42,0,0,1,128.54,374.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.74,397.55s3.28-5.23,7-6,5.31-5,6.68-2.44S144,400.22,132.74,397.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.78 418.07 113.92 418.07 111.52 395.94 152.18 395.94 149.78 418.07",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.02 400.13 110.68 400.13 110.14 395.45 153.56 395.45 153.02 400.13",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.02 400.13 110.68 400.13 110.14 395.45 153.56 395.45 153.02 400.13",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--painting-tools--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.79,325.46c1.34,1.7,8.46.66,9.75-1.22l-1.24-1s-7,3.56-10,.25Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.14,
    y: 305.01,
    width: 25.55,
    height: 29.78,
    transform: "translate(459.83 639.79) rotate(180)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.14,
    y: 305.01,
    width: 25.55,
    height: 29.78,
    transform: "translate(459.83 639.79) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.2,
    y: 304.46,
    width: 27.43,
    height: 2.01,
    transform: "translate(459.83 610.93) rotate(180)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.2,
    y: 304.46,
    width: 27.43,
    height: 2.01,
    transform: "translate(459.83 610.93) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.84,304.46h0a2.88,2.88,0,0,0-2.89,2.88v17.28a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1v-17.4a1.43,1.43,0,0,0-1.43-1.43h0a1.44,1.44,0,0,0-1.44,1.43v8a1,1,0,0,1-1,1H232a1,1,0,0,1-1-1v-7.4a3.36,3.36,0,0,0-3.36-3.36h13.16Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.14,
    y: 312.54,
    width: 11.42,
    height: 15.76,
    transform: "translate(445.7 640.84) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,305a.82.82,0,0,1,.11,1.21c-2.12,2.33-8.86,10.5-7.28,19.21l-1.48-2s-1.33-9.25,7.54-18.38A.83.83,0,0,1,222,305Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,305a.82.82,0,0,1,.11,1.21c-2.12,2.33-8.86,10.5-7.28,19.21l-1.48-2s-1.33-9.25,7.54-18.38A.83.83,0,0,1,222,305Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.25 334.79 208.25 418.07 213.28 418.07 213.28 344.46 266.63 344.46 266.63 418.07 271.67 418.07 271.67 334.79 208.25 334.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.25 334.79 208.25 418.07 213.28 418.07 213.28 344.46 266.63 344.46 266.63 418.07 271.67 418.07 271.67 334.79 208.25 334.79",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.24 334.79 194.24 418.07 199.28 418.07 199.28 344.46 252.62 344.46 252.62 418.07 257.66 418.07 257.66 334.79 194.24 334.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.24 334.79 194.24 418.07 199.28 418.07 199.28 344.46 252.62 344.46 252.62 418.07 257.66 418.07 257.66 334.79 194.24 334.79",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.17,
    y: 331.27,
    width: 27.08,
    height: 3.62,
    transform: "translate(431.41 666.16) rotate(180)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.72,
    y: 331.94,
    width: 27.97,
    height: 2.28,
    transform: "translate(431.41 666.16) rotate(180)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.72,
    y: 331.94,
    width: 27.97,
    height: 2.28,
    transform: "translate(431.41 666.16) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.66,
    y: 308.85,
    width: 1.14,
    height: 21.3,
    transform: "translate(459.13 677.82) rotate(-170.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.15,
    y: 311.13,
    width: 1.14,
    height: 21.3,
    transform: "translate(523.04 632.32) rotate(177.54)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.88 334.79 258.36 334.79 259.36 320.97 246.88 320.97 247.88 334.79",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,409.74c-1.34,1.7-8.46.66-9.75-1.22l1.24-1s7,3.56,10,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.68,
    y: 388.29,
    width: 25.55,
    height: 29.78,
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.68,
    y: 388.29,
    width: 25.55,
    height: 29.78,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.09,
    y: 388.74,
    width: 26.67,
    height: 2.43,
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.09,
    y: 388.74,
    width: 26.67,
    height: 2.43,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.8,
    y: 395.82,
    width: 16.82,
    height: 15.76,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.41,389.32a.82.82,0,0,0-.11,1.21c2.13,2.33,8.86,10.5,7.28,19.21l1.48-2s1.33-9.25-7.54-18.38a.84.84,0,0,0-1.11-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.41,389.32a.82.82,0,0,0-.11,1.21c2.13,2.33,8.86,10.5,7.28,19.21l1.48-2s1.33-9.25-7.54-18.38a.84.84,0,0,0-1.11-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 384.74,
    width: 27.08,
    height: 3.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.47,
    y: 385.41,
    width: 27.97,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.47,
    y: 385.41,
    width: 27.97,
    height: 2.28,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.9 418.07 371.78 418.07 342.91 204.94 334.03 204.94 362.9 418.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.9 418.07 371.78 418.07 342.91 204.94 334.03 204.94 362.9 418.07",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,236.53h28.22a1.86,1.86,0,0,0,1.63-1.08L376,231.9H340.92l1.8,3.55A1.83,1.83,0,0,0,344.34,236.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,236.53h28.22a1.86,1.86,0,0,0,1.63-1.08L376,231.9H340.92l1.8,3.55A1.83,1.83,0,0,0,344.34,236.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.57,
    y: 229.78,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(716.91 463.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.57,
    y: 229.78,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(716.91 463.37) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.49,267h28.22a1.86,1.86,0,0,0,1.63-1.08l1.79-3.54H346.07l1.79,3.54A1.86,1.86,0,0,0,349.49,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.49,267h28.22a1.86,1.86,0,0,0,1.63-1.08l1.79-3.54H346.07l1.79,3.54A1.86,1.86,0,0,0,349.49,267Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.71,
    y: 260.25,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(727.2 524.3) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.71,
    y: 260.25,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(727.2 524.3) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.64,307.32h28.22a1.83,1.83,0,0,0,1.62-1.08l1.8-3.54H351.22l1.79,3.54A1.86,1.86,0,0,0,354.64,307.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.64,307.32h28.22a1.83,1.83,0,0,0,1.62-1.08l1.8-3.54H351.22l1.79,3.54A1.86,1.86,0,0,0,354.64,307.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.86,
    y: 300.58,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(737.5 604.96) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.86,
    y: 300.58,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(737.5 604.96) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,347.65H388a1.83,1.83,0,0,0,1.62-1.08l1.79-3.54H356.37l1.79,3.54A1.85,1.85,0,0,0,359.78,347.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,347.65H388a1.83,1.83,0,0,0,1.62-1.08l1.79-3.54H356.37l1.79,3.54A1.85,1.85,0,0,0,359.78,347.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.01,
    y: 340.91,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(747.79 685.62) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.01,
    y: 340.91,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(747.79 685.62) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,388h28.22a1.86,1.86,0,0,0,1.63-1.08l1.79-3.55H361.51l1.8,3.55A1.83,1.83,0,0,0,364.93,388Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,388h28.22a1.86,1.86,0,0,0,1.63-1.08l1.79-3.55H361.51l1.8,3.55A1.83,1.83,0,0,0,364.93,388Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.16,
    y: 381.24,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(758.09 766.28) rotate(-180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.16,
    y: 381.24,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    transform: "translate(758.09 766.28) rotate(-180)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.17 418.07 406.05 418.07 377.18 204.94 368.31 204.94 397.17 418.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.17 418.07 406.05 418.07 377.18 204.94 368.31 204.94 397.17 418.07",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.77 294.84 336.61 296.49 343.57 280.95 335.74 279.32 328.77 294.84",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.74 279.32 343.56 280.96 339.59 289.84 331.89 287.87 335.74 279.32",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.91,293.3s0,.05,0,.06H339a9.71,9.71,0,0,0,2,.59,2.19,2.19,0,0,0,1.55-.16,1,1,0,0,0,.38-1,.73.73,0,0,0-.35-.59,3.29,3.29,0,0,0-2.23.22,2.86,2.86,0,0,0,1-1.75.71.71,0,0,0-.56-.67,1,1,0,0,0-.8.14c-.89.64-1,2.91-1,3h.14l-.14,0s-.13,0-.13,0A.2.2,0,0,0,338.91,293.3Zm.54-.51-.17.07c.09-.75.34-2,.88-2.37a.5.5,0,0,1,.42-.11l.09,0c.26.07.31.21.31.32A3.78,3.78,0,0,1,339.45,292.79Zm.08.4c1-.44,2.42-.91,2.91-.63a.34.34,0,0,1,.17.29.7.7,0,0,1-.23.64C342,293.8,340.9,293.68,339.53,293.19Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.44,292.18l-8.88-1.33a.57.57,0,0,0-.66.45h0l-1.49,7a1.42,1.42,0,0,0,1.17,1.61c3.11.42,4.61.46,8.53,1,2.4.35,7.11,1.28,10.46,1.25s3.24-3.35,1.82-3.63c-3.38-.69-7.68-3.59-9.64-5.67A2.3,2.3,0,0,0,338.44,292.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.96 418.07 295.09 418.07 323.95 204.94 332.83 204.94 303.96 418.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.96 418.07 295.09 418.07 323.95 204.94 332.83 204.94 303.96 418.07",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.8,236.53H328.57a1.84,1.84,0,0,1-1.62-1.08l-1.79-3.55h35l-1.79,3.55A1.84,1.84,0,0,1,356.8,236.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.8,236.53H328.57a1.84,1.84,0,0,1-1.62-1.08l-1.79-3.55h35l-1.79,3.55A1.84,1.84,0,0,1,356.8,236.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.8,
    y: 229.78,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.8,
    y: 229.78,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,267H323.43a1.86,1.86,0,0,1-1.63-1.08L320,262.37h35.06l-1.8,3.54A1.83,1.83,0,0,1,351.65,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,267H323.43a1.86,1.86,0,0,1-1.63-1.08L320,262.37h35.06l-1.8,3.54A1.83,1.83,0,0,1,351.65,267Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.65,
    y: 260.25,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.65,
    y: 260.25,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5,307.32H318.28a1.86,1.86,0,0,1-1.63-1.08l-1.79-3.54h35.06l-1.79,3.54A1.86,1.86,0,0,1,346.5,307.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5,307.32H318.28a1.86,1.86,0,0,1-1.63-1.08l-1.79-3.54h35.06l-1.79,3.54A1.86,1.86,0,0,1,346.5,307.32Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.5,
    y: 300.58,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.5,
    y: 300.58,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35,347.65H313.13a1.83,1.83,0,0,1-1.62-1.08l-1.8-3.54h35.06L343,346.57A1.86,1.86,0,0,1,341.35,347.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35,347.65H313.13a1.83,1.83,0,0,1-1.62-1.08l-1.8-3.54h35.06L343,346.57A1.86,1.86,0,0,1,341.35,347.65Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.35,
    y: 340.91,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.35,
    y: 340.91,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.21,388H308a1.84,1.84,0,0,1-1.62-1.08l-1.79-3.55h35.05l-1.79,3.55A1.84,1.84,0,0,1,336.21,388Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.21,388H308a1.84,1.84,0,0,1-1.62-1.08l-1.79-3.55h35.05l-1.79,3.55A1.84,1.84,0,0,1,336.21,388Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.21,
    y: 381.24,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.21,
    y: 381.24,
    width: 37.78,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.24 418.07 329.36 418.07 358.23 204.94 367.11 204.94 338.24 418.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.24 418.07 329.36 418.07 358.23 204.94 367.11 204.94 338.24 418.07",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,206H322.34a1.84,1.84,0,0,1-1.62-1.07l-1.8-3.55H382L380.23,205A1.85,1.85,0,0,1,378.61,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,206H322.34a1.84,1.84,0,0,1-1.62-1.07l-1.8-3.55H382L380.23,205A1.85,1.85,0,0,1,378.61,206Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.57,
    y: 199.28,
    width: 65.82,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.57,
    y: 199.28,
    width: 65.82,
    height: 3.81,
    rx: 1.77,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,170l24.65,5.42a1.07,1.07,0,0,0,1.27-.81h0a1.07,1.07,0,0,0-.82-1.28l-24.64-5.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.26,167.88A8.88,8.88,0,0,1,230.4,164l-1.55,5.19a7,7,0,0,0,5,.78Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.26,167.88A8.88,8.88,0,0,1,230.4,164l-1.55,5.19a7,7,0,0,0,5,.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,166.28a9.59,9.59,0,0,0,2.22,1.6L233.8,170a5.84,5.84,0,0,1-3.34-.11C231,168.68,231.54,167.49,232,166.28Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,168.25c.36-1.16.77-2.29,1.1-3.46a9.2,9.2,0,0,0,3.43,3.09L233.8,170a6.6,6.6,0,0,1-4.44-.52C229.48,169.05,229.6,168.65,229.73,168.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.02 381.03 303.95 379.89 305.15 362.92 297.24 364.07 296.02 381.03",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.24 364.07 305.15 362.93 304.46 372.63 296.56 373.42 297.24 364.07",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.48,376.36s0,0,0,.05h.06a10.11,10.11,0,0,0,2.13.1,2.18,2.18,0,0,0,1.46-.52,1,1,0,0,0,.14-1.06.68.68,0,0,0-.47-.49,3.2,3.2,0,0,0-2.12.72,2.89,2.89,0,0,0,.53-1.93.69.69,0,0,0-.7-.51.92.92,0,0,0-.74.32c-.72.83-.29,3.06-.28,3.18l.14,0h0l-.14.06-.11.06A.18.18,0,0,0,305.48,376.36Zm.41-.62a1,1,0,0,0-.15.11,4,4,0,0,1,.3-2.52.55.55,0,0,1,.39-.2h.09c.27,0,.35.13.37.23A3.79,3.79,0,0,1,305.89,375.74Zm.17.37c.87-.67,2.14-1.45,2.68-1.29a.33.33,0,0,1,.23.24.69.69,0,0,1-.07.68C308.55,376.14,307.51,376.27,306.06,376.11Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,375.38l-8.95.77a.56.56,0,0,0-.54.59h0l.17,7.13a1.41,1.41,0,0,0,1.51,1.28c3.12-.31,4.59-.62,8.53-1,2.42-.22,7.21-.41,10.47-1.22s2.37-4,.91-3.95c-3.44.11-8.29-1.7-10.69-3.28A2.33,2.33,0,0,0,304.77,375.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.22,232.25h0c0,.22,1.51,7,3.43,16.58.1.55.21,1.12.32,1.69.9,4.58,1.88,9.73,2.85,15.11,1.19,6.53,2.36,13.4,3.35,20a218.57,218.57,0,0,1,2.61,24.66c.47,20.77,1.33,61.77,1.33,61.77l11.19-1.76s6.18-43.72,6.1-64.89c0-5.7-.63-14-1.5-22.89-1.19-12.16-2.85-25.57-4.16-35.5-.13-1-.26-2-.39-2.93-1-7.23-1.64-12-1.64-12l-12.67.11Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.22,232.25h0c0,.22,1.51,7,3.43,16.58.1.55.21,1.12.32,1.69.9,4.58,1.88,9.73,2.85,15.11,1.19,6.53,2.36,13.4,3.35,20a218.57,218.57,0,0,1,2.61,24.66c.47,20.77,1.33,61.77,1.33,61.77l11.19-1.76s6.18-43.72,6.1-64.89c0-5.7-.63-14-1.5-22.89-1.19-12.16-2.85-25.57-4.16-35.5-.13-1-.26-2-.39-2.93-1-7.23-1.64-12-1.64-12l-12.67.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,240.51s9,34.32,17.35,42c-1.19-12.16-2.85-25.57-4.16-35.5-.13-1-.26-2-.39-2.93A28.86,28.86,0,0,0,292.55,240.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,249.6l.76-.18,40.36-5-15.74,40.11,12.42,3.11s31.41-53.08,20-60.84-46.69.81-46.69.81l-1.39-10.64-35.11,2.62C274.94,254.62,301.12,250.62,306,249.6Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,249.6l.76-.18,40.36-5-15.74,40.11,12.42,3.11s31.41-53.08,20-60.84-46.69.81-46.69.81l-1.39-10.64-35.11,2.62C274.94,254.62,301.12,250.62,306,249.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.25,173.79a140.88,140.88,0,0,1-8.49,20.55c-1.56,2.84-3,5.63-5.58,8-10.76,9-17.81-16.77-19.81-23.77l4.52-1.74c3.34,5.95,6.54,12.42,10.67,17.66a8.1,8.1,0,0,0,.89.93c.26.24.52.37.37.25a2.8,2.8,0,0,0-1.92-.2,3.23,3.23,0,0,0-.56.2c-.2.1-.2.12-.16.06,2.54-3.45,4.15-7.88,5.84-11.91,1.72-4.31,3.38-8.78,5-13.14l9.27,3.13Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,167.65c-4.71,1.52-10.4,20.4-10.4,20.4l10.4,8.33L280,182.83Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,182.83l-1,1.65-5.52,9-1.78,2.9-10.4-8.33s5.69-18.88,10.4-20.4Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,184.48l-5.52,9c.13-6.27,3.13-13.21,3.13-13.21A13.14,13.14,0,0,1,279,184.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.11 222.96 280.37 223.02 280.4 220.59 281.06 220.54 281.11 222.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.71 220.81 293.73 221.98 293.67 219.57 308.58 218.41 308.71 220.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.74 218.32 316.07 217.84 316.3 220.22 309.89 220.72 309.74 218.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.22 220.45 292.51 219.66 292.56 222.07 282.29 222.87 282.22 220.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.11 222.96 280.37 223.02 280.4 220.59 281.06 220.54 281.11 222.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.71 220.81 293.73 221.98 293.67 219.57 308.58 218.41 308.71 220.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.74 218.32 316.07 217.84 316.3 220.22 309.89 220.72 309.74 218.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.22 220.45 292.51 219.66 292.56 222.07 282.29 222.87 282.22 220.45",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.63,145.62c0,.55-.21,1-.57,1s-.68-.39-.73-.94.21-1,.57-1S280.58,145.07,280.63,145.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.47,146.63a19.75,19.75,0,0,1-2.22,4.91,3.14,3.14,0,0,0,2.66.27Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,142.4a.31.31,0,0,0,.18-.14.31.31,0,0,0-.11-.44,3.25,3.25,0,0,0-2.94-.26.33.33,0,0,0,.29.59h0a2.55,2.55,0,0,1,2.32.22A.3.3,0,0,0,282.38,142.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.43,150.54c-1.44,4.87-3.25,13.89-.08,17.53,0,0-1.83,4.91-11.06,4.06-10.15-.94-4.39-5.49-4.39-5.49,5.67-.81,5.91-4.94,5.3-8.89Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.81,142.9c.16,6.77.6,10.73-2.51,14.47-4.67,5.63-13.24,3.25-15.42-3.33-2-5.93-1.89-16,4.47-19.24A9.23,9.23,0,0,1,298.81,142.9Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,154c-2.22,2.31-13.44.06-13.71-8.26,0,0-5-3.37-6-8.41s1.8-7.9,5.7-7.9c3.44,0,3.85,1.76,3.85,1.76s15.48-2.62,14.07,4.39C310.84,140.42,301.7,151.1,298.93,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,146.3a7.74,7.74,0,0,1-1.5,4.68c-1.33,1.77-3,.89-3.41-1.07-.4-1.77-.19-4.82,1.53-5.88S288.15,144.27,288.22,146.3Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.15 166.57 236.95 171.07 240.55 176.66 248.35 171.65 243.15 166.57",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,179.91l-2-8.26-7.81,5s3.18,6.92,6.66,6.24Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.68,192.89c.45,7.69.68,18.34.41,27.29l-37.91,2.74s-1.88-33.06-7.51-55.27c0,0,24.09-7.09,41.8-4.69,0,0,.87,5,1.78,13.17C315.77,180.81,316.3,186.52,316.68,192.89Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.68,192.89c.45,7.69.68,18.34.41,27.29l-37.91,2.74s-1.88-33.06-7.51-55.27c0,0,24.09-7.09,41.8-4.69,0,0,.87,5,1.78,13.17C315.77,180.81,316.3,186.52,316.68,192.89Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.68,192.89c-6.78-6.48-9.49-18-9.49-18a17.15,17.15,0,0,1,8.06,1.22C315.77,180.81,316.3,186.52,316.68,192.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62,165.66a4.57,4.57,0,0,1,2.72-3.94c4.58-2.1,17.37-3.44,20.15.75C302.49,162.47,287.25,179.58,279.62,165.66Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62,165.66a4.57,4.57,0,0,1,2.72-3.94c4.58-2.1,17.37-3.44,20.15.75C302.49,162.47,287.25,179.58,279.62,165.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,167c3.78,5.62,7.6,11.52,11.84,16.74a20.63,20.63,0,0,0,2.91,3c8.68,3.65,18.19,6.91,26.88,10.65L357.73,202q-7.05-1.28-14-3c-5-1.26-9.93-2.43-14.91-4.19a10.51,10.51,0,0,1-2-1.08c-3.72-2.62-6.54-6.22-9.27-9.63a138.2,138.2,0,0,1-8.32-12l8.27-5.24Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.48 196.43 371.37 204.01 364.74 203.41 365.56 194.17 372.48 196.43",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,196.22l8.25-2.05-.82,9.24s-7.61.39-8.61-3Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,163c4.67.84,15,19.87,15,19.87L317.76,191S306.94,181,306.33,175.09C305.22,164.51,313.47,163,313.47,163Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,163c4.67.84,15,19.87,15,19.87L317.76,191S306.94,181,306.33,175.09C305.22,164.51,313.47,163,313.47,163Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingonthewallRafiki);
export default __webpack_public_path__ + "static/media/Writing on the wall-rafiki.021679b705d3ab9356cea0416744f29e.svg";
export { ForwardRef as ReactComponent };